// Local wall-clock helpers. Opportunity/task dates are stored as "YYYY-MM-DDTHH:MM".
export const pad = (n) => String(n).padStart(2, "0");
export const ymd = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const todayStr = () => ymd(new Date());
export const addDays = (d, n) => {
  const x = new Date(d);
  x.setDate(x.getDate() + n);
  return x;
};
export const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
export const startOfWeek = (d) => addDays(startOfDay(d), -((d.getDay() + 6) % 7));
export const parseLocal = (s) => {
  const [dPart, tPart = "00:00"] = String(s).split("T");
  const [y, m, dd] = dPart.split("-").map(Number);
  const [h, mi] = tPart.split(":").map(Number);
  return new Date(y, m - 1, dd, h || 0, mi || 0);
};
export const fmtLocal = (s) => {
  if (!s) return "—";
  const d = parseLocal(s);
  const year = d.getFullYear() !== new Date().getFullYear() ? { year: "numeric" } : {};
  return d.toLocaleString(undefined, { weekday: "short", day: "numeric", month: "short", ...year, hour: "numeric", minute: "2-digit" });
};
export const fmtTime = (s) => parseLocal(s).toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
